import { previewFacebookSources } from './facebook';
import { previewInstagramSources } from './instagram';
import { previewLinkedinSources } from './linkedin';
import { previewPinterestSources } from './pinterest';
import { previewRssSources } from './rss';
import { previewTiktokSources } from './tiktok';
import { previewTumblrSources } from './tumblr';
import { previewTwitterSources } from './twitter';
import { previewVimeoSources } from './vimeo';
import { previewVkontakteSources } from './vkontakte';
import { previewYoutubeSources } from './youtube';

export * from './facebook';
export * from './instagram';
export * from './linkedin';
export * from './pinterest';
export * from './rss';
export * from './tiktok';
export * from './tumblr';
export * from './twitter';
export * from './types';
export * from './vimeo';
export * from './vkontakte';
export * from './youtube';

export const previewSources = {
  ...previewFacebookSources,
  ...previewInstagramSources,
  ...previewLinkedinSources,
  ...previewTwitterSources,
  ...previewPinterestSources,
  ...previewRssSources,
  ...previewVkontakteSources,
  ...previewTiktokSources,
  ...previewYoutubeSources,
  ...previewVimeoSources,
  ...previewTumblrSources
};
